<app-horizontal-scroll>

  <a [routerLink]="getDetailViewUrl(item)" *ngFor="let item of items">
    <div class="os-item-container">
      <div class="os-image-container">
        <img alt="" class="os-item-image" [src]="getImageUrl(item)">

        <ng-container *ngIf="item._inWishlist">
          <div class="wishlist-indicator"></div>
          <img alt="" class="wishlist-star-indicator" src="./assets/images/star_filled_blue.png">
        </ng-container>

        <div *ngIf="item._inOwnlist" class="purchased-icon">{{getString('purchased')}}</div>

        <!-- Quick actions bar on hover -->
        <div class="quick-actions-bar">
          <div class="quick-action" [class.active]="item._inWishlist" (click)="toggleWishlist($event, item)">
            <img alt="" [src]="item._inWishlist ? './assets/images/star_filled_blue.png' : './assets/images/star_filled_black.png'">
            <span class="action-label">{{getString('wishlist')}}</span>
          </div>
          <div class="quick-action" [class.active]="item._inOwnlist" (click)="toggleOwnlist($event, item)">
            <img alt="" src="./assets/images/my_purchases_check.png">
            <span class="action-label">{{getString('purchased')}}</span>
          </div>
        </div>
      </div>

      <div class="os-footer">
        <span class="os-season-number">{{getSeasonsNumberString(item.title)}}</span>
        <div class="os-price-container">
          <app-grid-item-prices [item]="item" [priceHint]="'offerslist'"></app-grid-item-prices>
        </div>
      </div>
    </div>
  </a>

</app-horizontal-scroll>
